import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  FlutterIcon,
  HealthcareIcon,
  ReactIcon,
} from "../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android App Development",
    description:
      "Take your business to unprecedented heights with TekRevol’s leading Android app development services in NYC. With our customised interface offering a tailored user experience, you can find yourself as an audience favourite, and start leading in the tech market. Currently, our team is helping different industries with robust apps and unrivalled solutions.",
  },
  {
    icon: IphoneIcon,
    title: "iPhone App Development",
    description:
      "TekRevol can help businesses from various niches successfully scale and achieve top results through their high-performance native game app developers. We specialize in harnessing maximum potential with cutting-edge iOS development tools and programming languages like Swift, Xcode, Objective C, and more. Based in New York, our iOS app services fuel your app venture, from consumer apps to intricate on-demand solutions.",
  },
  {
    icon: GameIcon,
    title: "Game App Development",
    description:
      "Game App Development Partner with TekRevol, an experienced game app development firm in integrating AR, VR, Blockchain, and NFTs in gaming environments. With our unmatched services, your game idea can be the next big thing in this vast industry, and you can capitalize on new gaming arenas worldwide. You just need to unveil a game with new ideas and monetize with the help of ads, sponsored content, and premium subscribers.",
  },
  {
    icon: FlutterIcon,
    title: "Flutter app development",
    description: (
      <>
        If you want cost-effective solutions, TekRevol can help you create a
        state-of-the-art app by utilizing{" "}
        <Link
          to="/flutter-app-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          Flutter App Development
        </Link>{" "}
        .Flutter is cross-platform compatible, and with its help, you can craft
        top-performing mobile apps that can work on Android and iOS operating
        systems and their compatible devices. So, develop your app at a
        reasonable price and maximize your results with Flutter application
        development.
      </>
    ),
  },
  {
    icon: HealthcareIcon,
    title: "Healthcare app development",
    description:
      "TekRevol has all the resources and ability to develop state-of-the-art healthcare services. Revolutionise the complex tasks assigned to healthcare professionals and simplify their workload, so they can maximise their potential in focusing on other intricate responsibilities. Our healthcare mobile app solutions guarantee to take you over and beyond your competition.",
  },
  {
    icon: ReactIcon,
    title: "React Native app development",
    description:
      "At TekRevol, we are well equipped with state-of-the-art technology to utilize React native app development’s full potential to attain our client’s goals. Renowned for its exceptional user interface and flawless performance, React Native stands as one of the preferred choices of many businesses that want to digitize their operations.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>
              Business Empowering Mobile App Development Services in New York
            </h2>
            <p className="impro_para">
              Utilising the skill of the top mobile app developers in New York
              City, we provide customised application and digital solutions
              relevant to your requirements. Opt for our mobile app development
              services in NYC, and avail a robust and trustworthy mobile app
              that will help you compete with industry leaders.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
